"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.Wrapper = exports.Label = exports.ErrorMessage = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)("width:100%;padding:0.75em;border:1px solid #d7d7d7;border-radius:3px;font-size:16px;box-sizing:border-box;outline:0;min-height:50px;&:focus{border:2px solid ", theme.border, ";padding:calc(0.75em - 1px);}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  resize: resize => /*#__PURE__*/(0, _react.css)("resize:", resize, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:resize;")),
  maxHeight: value => /*#__PURE__*/(0, _react.css)("max-height:", value, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:maxHeight;")),
  disabled: theme => /*#__PURE__*/(0, _react.css)("cursor:'not-allowed';background-color:", theme.disabled, ";border-color:", theme.disabled, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:disabled;"))
};
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eb6f8862"
} : {
  target: "eb6f8862",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1iq60ec",
  styles: "display:grid;grid-row-gap:0.5em"
} : {
  name: "1iq60ec",
  styles: "display:grid;grid-row-gap:0.5em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Label = exports.Label = /*#__PURE__*/(0, _base.default)("label", process.env.NODE_ENV === "production" ? {
  target: "eb6f8861"
} : {
  target: "eb6f8861",
  label: "Label"
})(process.env.NODE_ENV === "production" ? {
  name: "tr7v0r",
  styles: "font-size:16px;font-weight:600;height:20px;line-height:20px"
} : {
  name: "tr7v0r",
  styles: "font-size:16px;font-weight:600;height:20px;line-height:20px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ErrorMessage = exports.ErrorMessage = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "eb6f8860"
} : {
  target: "eb6f8860",
  label: "ErrorMessage"
})(props => /*#__PURE__*/(0, _react.css)("font-size:14px;padding-left:25px;margin-bottom:0;color:", props.theme.alert, ";position:relative;svg{position:absolute;left:3px;path{fill:", props.theme.alert, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:ErrorMessage;")));